/**
 * Sends a signed-out visitor to the login page, remembering where they were headed so the login
 * page can bring them back (e.g. a payment link opened from an email).
 *
 * Uses replace so the back button doesn't bounce the visitor straight back into this redirect.
 * @param {Function} navigate the function returned by react-router's useNavigate
 */
export function redirectToLogin (navigate) {
    const returnUrl = window.location.pathname + window.location.search;
    navigate(`/login?returnUrl=${encodeURIComponent(returnUrl)}`, { replace: true });
}

/**
 * The returnUrl query value if it is safe to navigate to, otherwise null.
 *
 * Only same-site paths are allowed. Anything absolute or protocol-relative ("//evil.com") would
 * let a crafted login link send the visitor off-site after they sign in.
 * @param {string|null} returnUrl
 * @returns {string|null}
 */
export function getSafeReturnUrl (returnUrl) {
    if (!returnUrl || !returnUrl.startsWith('/') || returnUrl.startsWith('//') || returnUrl.startsWith('/\\')) {
        return null;
    }

    if (returnUrl.toLowerCase().startsWith('/login')) {
        return null;
    }

    return returnUrl;
}
